import { GetMonthlyInvoicePeriodDtoMeter, EnergyTypeDto, BillingAccountRelatedMeterResponse } from '@eneco/dc-be/client';
import mapScEnumToMap from '@eneco/dc-be/utils/mapScEnumToMap';

type GetBillingAccountLabel = {
  consumptionTypesList: { value: { enum: { name: string; label: string; value: string }[] } };
  meters: GetMonthlyInvoicePeriodDtoMeter[] | BillingAccountRelatedMeterResponse[];
  eanLabel: { value: string };
};

export const getBillingAccountLabel = ({ consumptionTypesList, meters, eanLabel }: GetBillingAccountLabel) => {
  const energyTypeMap = mapScEnumToMap<EnergyTypeDto>(consumptionTypesList.value);
  const meterLabels: string[] = [];
  meters.forEach(meter => {
    const ean = `${eanLabel.value ?? 'EAN [Not in Sitecore]'} ${meter.ean}`;
    const energyType = meter.energyType;
    const energyTypeFromMap = energyTypeMap.get(energyType);
    meterLabels.push(`${energyTypeFromMap} - ${ean}`);
  });
  return meterLabels.join(' / ');
};
